//@flow
import FunctionStore from '../Base/functionStoreClass';
import { setFlag } from '../Base/storeUtils';
import Constants from '../../constants';
import ExperimentsStore from '../Experiments/experimentsStore';
import Cookies from '../../Utils/cookies-data';

import type { HandlerAdd } from '../Base/functionStoreClass';

export default class ShellStoreClass extends FunctionStore {
  cartPreviewOpen():boolean {
    return this._getFlag('cartPreviewOpen');
  }

  isLoading():boolean {
    return this._getFlag('isLoading');
  }

  _setup(onSuccess:HandlerAdd, onError:HandlerAdd) {
    onSuccess(Constants.IS_LOADING, _addLoadingSpinner);
    onSuccess(Constants.LOAD_COMPLETED, _removeLoadingSpinner);

    onSuccess(Constants.OPEN_CART_PREVIEW, _openCartPreview);
    onSuccess(Constants.CLOSE_CART_PREVIEW, _closeCartPreview);
    onSuccess(Constants.CHANGING_ROUTE, _closeCartPreview);

    onSuccess(Constants.ADD_QUOTE_ITEM, [_addLoadingSpinner, _openCartPreviewFirstTime],
      [ ExperimentsStore ]);
    onSuccess(Constants.UPDATE_QUOTE_ITEM_QTY, _addLoadingSpinner);
    onSuccess(Constants.DELETE_QUOTE_ITEM, _addLoadingSpinner);

    onSuccess(Constants.ADD_QUOTE_ITEM_SUCCESS, _removeLoadingSpinner);
    onSuccess(Constants.UPDATE_QUOTE_ITEM_QTY_SUCCESS, _removeLoadingSpinner);
    onSuccess(Constants.DELETE_QUOTE_ITEM_SUCCESS, _removeLoadingSpinner);

    onSuccess(Constants.CHANGING_ROUTE, _removeLoadingSpinner);
    onError(Constants.ERROR, _removeLoadingSpinner);
    onError(Constants.NOT_AUTHORIZED, _removeLoadingSpinner);
  }
}

function _openCartPreviewFirstTime(store:FunctionStore) {
  _openCartPreview(store);
}

function _openCartPreview(store:FunctionStore) {
  Cookies.setCartPreviewOpened();
  store._setFlag('cartPreviewOpen', true);
}

const _closeCartPreview = setFlag('cartPreviewOpen', false);

const _addLoadingSpinner = setFlag('isLoading', true);
const _removeLoadingSpinner = setFlag('isLoading', false);
